<div class="empty-container">
  <div class="empty-inner">
    <img class="img" [src]="img" />
    <label class="header">{{ header }}</label>
    <label class="description">{{ description }}</label>
    @if (type == 'action') {
      <p-button class="button-style" severity="primary" (click)="buttonClicked()">
        {{ buttonText }}
      </p-button>
    }
  </div>
</div>
